<script>
import { Message } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit Message',
      verboseName: 'Wiadomość',
      verboseNamePlural: 'Wiadomości',
      fullWidth: true,
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'first_name', label: 'Imię' },
        { prop: 'last_name', label: 'Nazwisko' },
        { prop: 'email', label: 'Email' },
        { prop: 'company', label: 'Firma' }
      ]
    }
  },
  computed: {
    service() {
      return Message
    }
  },
  methods: {
    actions(scope) {
      return [
        {
          component: 'router-link',
          attrs: {
            to: this.getEditRoute(scope.row)
          },
          children: [this.getButtonComponent({ icon: 'fa fa-edit' })]
        },
        ...this.additionalActions(scope)
      ]
    }
  }
}
</script>
